<ng-container *appLet="isLoading$ | async as isLoading">
  <app-inline-spinner *ngIf="isLoading">
    <app-typography variant="p">{{ 'SEARCH.LOADING' | translate  }}</app-typography>
  </app-inline-spinner>
  <app-typography *ngIf="!isLoading" variant="p">
    {{ resultsCount$ | async | plural:'THERAPIST_RESULTS' }}
  </app-typography>
</ng-container>
